import { chargeNote } from './chargeDisplay';
import moment from 'moment';

export interface FormattedTransaction {
  isPaycheck: boolean;
  title: string;
  subtitle: string;
  amountText: string;
  isCredit: boolean;
  icon: string;
  iconBg: string;
  iconColor: string;
  payPeriodLabel?: string;
  payrollSnapshot?: any;
}

/**
 * Parses and formats transaction rows for clean presentation,
 * handling specialized transaction types like Paychecks / Payroll entries.
 */
export function formatTransactionItem(row: any): FormattedTransaction {
  const isCredit = row?.transaction_type?.type === 'credit';
  const typeName = (row?.transaction_type?.name || '').trim();
  const desc = (row?.description || '').trim();
  const reason = (row?.reason || '').trim();
  const amount = Number(row?.amount || 0);
  const payroll = row?.extendedproperties?.payroll;

  const isPaycheck =
    Boolean(payroll) ||
    typeName.toLowerCase().includes('paycheck') ||
    desc.toLowerCase().startsWith('paycheck') ||
    reason.toLowerCase().includes('payroll');

  if (isPaycheck) {
    // 1. Format Pay Period Range
    let payPeriodLabel = '';
    const payPeriodKey =
      payroll?.pay_period_key ||
      desc.match(/(\d{4}-\d{2}-\d{2})_(\d{4}-\d{2}-\d{2})/)?.[0] ||
      '';

    if (payPeriodKey && payPeriodKey.includes('_')) {
      const [start, end] = payPeriodKey.split('_');
      if (start && end) {
        payPeriodLabel = `${moment(start).format('MMM D')} – ${moment(end).format('MMM D, YYYY')}`;
      }
    }

    const title = 'Scholar Paycheck';
    const subtitle = payPeriodLabel || 'Biweekly Grade Payroll';
    const net = Number(payroll?.net ?? amount ?? 0);

    return {
      isPaycheck: true,
      title,
      subtitle,
      amountText: `+$${net.toFixed(2)}`,
      isCredit: true,
      icon: 'solar:bill-check-bold-duotone',
      iconBg: 'rgba(16, 185, 129, 0.12)',
      iconColor: '#059669',
      payPeriodLabel,
      payrollSnapshot: payroll,
    };
  }

  // Standard non-payroll transaction
  return {
    isPaycheck: false,
    title: typeName || desc || reason || 'Ledger Entry',
    // Old rows carry filler ("Regular debit transaction", "Monthly Rent (-$350)"); chargeNote hides it.
    subtitle: chargeNote(row) || (isCredit ? 'Credit deposit' : 'Debit deduction'),
    amountText: `${isCredit ? '+' : '-'}$${amount.toFixed(2)}`,
    isCredit,
    icon: isCredit ? 'solar:card-recive-bold-duotone' : 'solar:card-send-bold-duotone',
    iconBg: isCredit ? 'rgba(16, 185, 129, 0.12)' : 'rgba(239, 68, 68, 0.12)',
    iconColor: isCredit ? '#059669' : '#DC2626',
  };
}
